<template>
  <div class="lfe-page">

    <!-- Hero -->
    <div class="lfe-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-receipt-text-outline</v-icon>
        </v-avatar>
        <div>
          <div class="lfe-hero__title">Listado de Facturas por NIT</div>
          <div class="lfe-hero__sub">Consulta por período y NIT externo</div>
        </div>
      </div>
      <div class="d-flex align-center" style="gap:8px;">
        <v-chip small color="rgba(255,255,255,0.15)" dark>
          <v-icon left small>mdi-bank-outline</v-icon> Facturación
        </v-chip>
        <v-btn small dark text @click="$router.back()">
          <v-icon left small>mdi-arrow-left</v-icon> Volver
        </v-btn>
      </div>
    </div>

    <div class="lfe-body">

      <!-- Filtros -->
      <v-card outlined class="lfe-filters-card mb-4">
        <v-card-title class="lfe-filters-card__title py-2 px-4">
          <v-icon small color="indigo darken-2" class="mr-1">mdi-filter-outline</v-icon>
          Parámetros de consulta
        </v-card-title>
        <v-card-text class="pt-3 pb-3 px-4">
          <v-row dense align="center">
            <v-col cols="12" sm="2">
              <v-select label="Gestión" v-model="gestion" :items="gestiones"
                outlined hide-details dense prepend-inner-icon="mdi-calendar-range" />
            </v-col>
            <v-col cols="12" sm="3">
              <v-select label="Mes" v-model="mes" :items="meses" item-value="id" item-text="mes"
                outlined hide-details dense prepend-inner-icon="mdi-calendar-month-outline" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-select label="Seleccione un NIT" v-model="nicsel" :items="nics"
                :disabled="!gestion || !mes"
                clearable outlined hide-details dense prepend-inner-icon="mdi-office-building" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card outlined class="lfe-table-card">

        <!-- Toolbar -->
        <div class="lfe-table-toolbar px-4 py-2 d-flex align-center flex-wrap" style="gap:8px;">
          <v-text-field
            v-show="facturas.length"
            v-model="buscar"
            dense outlined hide-details clearable
            placeholder="Buscar en la tabla..."
            prepend-inner-icon="mdi-magnify"
            style="max-width:300px;"
          />
          <v-spacer />
          <v-chip x-small :color="facturas.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ facturas.length }} registro{{ facturas.length !== 1 ? 's' : '' }}
          </v-chip>
        </div>

        <v-divider />

        <p v-if="msg" class="text-center red--text ma-2" style="font-size:0.85rem;">{{ msg }}</p>

        <v-data-table
          :headers="headers"
          :items="facturas"
          :loading="loading"
          :search="buscar"
          :item-class="rowClass"
          dense
          loading-text="Cargando facturas..."
          no-data-text="Sin facturas. Seleccione los filtros para consultar."
          class="lfe-table"
        >
          <!-- Estado -->
          <template v-slot:[`item.estado`]="{ item }">
            <v-chip x-small label
              :color="item.estado === 'ANULADA' ? 'red lighten-5' : 'green lighten-5'"
              :class="item.estado === 'ANULADA' ? 'red--text text--darken-2' : 'green--text text--darken-2'">
              <v-icon left x-small>{{ item.estado === 'ANULADA' ? 'mdi-close-circle-outline' : 'mdi-check-circle-outline' }}</v-icon>
              {{ item.estado === 'ANULADA' ? 'Anulada' : 'Válida' }}
            </v-chip>
          </template>

          <!-- Opciones -->
          <template v-slot:[`item.opciones`]="{ item }">
            <v-menu left :close-on-content-click="false" offset-x tile max-width="560">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon x-small color="indigo darken-1" v-bind="attrs" v-on="on">
                  <v-icon x-small>mdi-eye-outline</v-icon>
                </v-btn>
              </template>

              <v-card class="lfe-detail-card" width="560">
                <div class="lfe-detail-header px-4 py-3">
                  <span class="white--text font-weight-bold" style="font-size:0.9rem;">
                    <v-icon color="white" small class="mr-1">mdi-file-document-outline</v-icon>
                    Detalle de la factura
                  </span>
                </div>
                <v-divider />
                <v-card-text class="pa-3">
                  <v-row dense>
                    <v-col cols="12" sm="4">
                      <div class="lfe-drow"><span class="lfe-dk">Especificación</span><span class="lfe-dv">{{ item.especificacion }}</span></div>
                      <div class="lfe-drow"><span class="lfe-dk">Fecha</span><span class="lfe-dv">{{ item.fecha }}</span></div>
                      <div class="lfe-drow"><span class="lfe-dk">Fecha lím. emisión</span><span class="lfe-dv">{{ item.fecha_limite_emision }}</span></div>
                      <div class="lfe-drow"><span class="lfe-dk">Fecha registro</span><span class="lfe-dv">{{ item.fecha_registro }}</span></div>
                      <div class="lfe-drow"><span class="lfe-dk">Hora</span><span class="lfe-dv">{{ item.hora }}</span></div>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <div class="lfe-drow"><span class="lfe-dk">Nro factura</span><span class="lfe-dv">{{ item.numero_factura }}</span></div>
                      <div class="lfe-drow"><span class="lfe-dk">Nro autorización</span><span class="lfe-dv">{{ item.numero_autorizacion }}</span></div>
                      <div class="lfe-drow"><span class="lfe-dk">Estado</span><span class="lfe-dv">{{ item.estado }}</span></div>
                      <div class="lfe-drow"><span class="lfe-dk">NIT cliente</span><span class="lfe-dv">{{ item.nit_cliente }}</span></div>
                      <div class="lfe-drow"><span class="lfe-dk">NIT empresa</span><span class="lfe-dv">{{ item.nit_empresa }}</span></div>
                      <div class="lfe-drow"><span class="lfe-dk">Razón social</span><span class="lfe-dv">{{ item.razon_social }}</span></div>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <div class="lfe-drow"><span class="lfe-dk">Imp. total venta</span><span class="lfe-dv">{{ item.importe_total_venta }}</span></div>
                      <div class="lfe-drow"><span class="lfe-dk">Importe IVA</span><span class="lfe-dv">{{ item.importe_iva }}</span></div>
                      <div class="lfe-drow"><span class="lfe-dk">Exportaciones</span><span class="lfe-dv">{{ item.exportaciones }}</span></div>
                      <div class="lfe-drow"><span class="lfe-dk">Ventas tasa cero</span><span class="lfe-dv">{{ item.ventas_tasa_cero }}</span></div>
                      <div class="lfe-drow"><span class="lfe-dk">Subtotal</span><span class="lfe-dv">{{ item.subtotal }}</span></div>
                      <div class="lfe-drow"><span class="lfe-dk">Descuentos IVA</span><span class="lfe-dv">{{ item.descuentos_iva }}</span></div>
                      <div class="lfe-drow"><span class="lfe-dk">Importe fiscal</span><span class="lfe-dv">{{ item.importe_fiscal }}</span></div>
                      <div class="lfe-drow"><span class="lfe-dk">Débito fiscal</span><span class="lfe-dv">{{ item.debito_fiscal }}</span></div>
                      <div class="lfe-drow"><span class="lfe-dk">Cód. control</span><span class="lfe-dv">{{ item.codigo_control }}</span></div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-menu>
          </template>
        </v-data-table>

        <FacturasDownload :facturas="facturas" :datosdescarga="datosdescargas" />
      </v-card>

    </div>
  </div>
</template>

<script>
  import FacturasDownload from '@/components/facturastoexcel.vue';
  import { getheadersrest } from '@/components/Utils';
  import gql from 'graphql-tag';
  import xaxios from '@/xaxios';

  export default {
    data() {
      return {
        api_rest: process.env.VUE_APP_API_REST,
        sede: null,
        msg: '',
        loading: false,
        datosdescargas: {},
        seleccionado: {},
        sucursales: [],
        facturasall: [],
        facturas: [],
        nicsel: null,
        nits: [],
        nics: [],
        busqueda: {
          fecha_ini: null,
          fecha_fin: null,
        },
        mes: null,
        gestion: null,
        meses: [
          { id: 1,  mes: 'Enero' },
          { id: 2,  mes: 'Febrero' },
          { id: 3,  mes: 'Marzo' },
          { id: 4,  mes: 'Abril' },
          { id: 5,  mes: 'Mayo' },
          { id: 6,  mes: 'Junio' },
          { id: 7,  mes: 'Julio' },
          { id: 8,  mes: 'Agosto' },
          { id: 9,  mes: 'Septiembre' },
          { id: 10, mes: 'Octubre' },
          { id: 11, mes: 'Noviembre' },
          { id: 12, mes: 'Diciembre' },
        ],
        gestiones: [2027, 2026, 2025, 2024, 2023, 2022, 2021, 2020],
        buscar: '',
        headers: [
          { text: '#',           value: 'nro',                  width: '50',  sortable: false },
          { text: 'No. Factura', value: 'numero_factura',        width: '110' },
          { text: 'NIT Empresa', value: 'nit_empresa',           width: '120' },
          { text: 'NIT Cliente', value: 'nit_cliente',           width: '110' },
          { text: 'Cliente',     value: 'nombre_cliente' },
          { text: 'Imp. Total',  value: 'importe_total_venta',   width: '110' },
          { text: 'No. Auth',    value: 'numero_autorizacion' },
          { text: 'Estado',      value: 'estado',                width: '100' },
          { text: 'Opciones',    value: 'opciones',              width: '70',  sortable: false },
        ],
      };
    },
    components: { FacturasDownload },
    watch: {
      '$store.state.CARGO': function() {
        this.sede = this.$store.state.CARGO.idsede;
        this.getSucursales(this.sede);
        this.nicsel = null;
        this.facturas = [];
        window.console.log(this.$store.state.CARGO);
      },
      gestion: function() {
        this.facturas = [];
        this.nicsel = null;
      },
      mes: function() {
        this.facturas = [];
        this.nicsel = null;
      },
      nicsel: function() {
        if (!this.nicsel) return;
        let m = this.meses.find((x) => x.id == this.mes).mes;
        let filename = `${this.nicsel}-${this.gestion}-${m}`;
        this.datosdescargas.filename = filename;
        this.facturas = [];
        this.getDatosFacturas();
      },
    },
    methods: {
      rowClass(item) {
        return item.estado === 'ANULADA' ? 'lfe-row--anulada' : '';
      },
      editar(obj) {
        this.seleccionado = obj;
      },
      modalExitof() {},
      parsesede(s) {
        if (!s) return;
        let guion = s.indexOf('-') + 2;
        return s.substring(guion, s.length);
      },
      async getDatos(datosserver) {
        const vue = this;
        datosserver.sort(function(a, b) {
          return a.numero_autorizacion - b.numero_autorizacion || a.numero_factura - b.numero_factura;
        });
        window.console.log('FACTURAS:\n', datosserver);
        datosserver.forEach(function(dem) {
          let fs = dem.fecha.split('-');
          dem.importe_total_venta = dem.monto;
          dem.especificacion = 3;
          dem.importe_iva = 0;
          dem.exportaciones = 0;
          dem.ventas_tasa_cero = 0;
          dem.subtotal = dem.monto;
          dem.descuentos_iva = 0;
          dem.importe_fiscal = dem.monto;
          dem.fecha_slash = `${fs[2]}/${fs[1]}/${fs[0]}`;
          dem.nombre_cliente = dem.nombre_cliente.toUpperCase();
          vue.facturasall.push(dem);
          if (vue.nicsel == dem.nit_empresa) {
            dem.nro = vue.facturas.length + 1;
            vue.facturas.push(dem);
          }
        });
      },
      async getSucursales(idsede) {
        this.sucursales = await xaxios
          .post(`${this.api_rest}/esam/sucursales`, { sede_id: idsede })
          .then(({ data }) => (data ? data : []))
          .catch(() => [{ id: 1, ciudad_nit: 'Tarija - 123456789', ciudad: 'Tarija' }]);
        window.console.log('SUCURSALES: ', this.sucursales);
      },
      getfechasrango() {
        let date_inicio = new Date();
        date_inicio.setDate(1);
        date_inicio.setFullYear(this.gestion);
        date_inicio.setMonth(this.mes - 1);
        let date_final = new Date();
        date_final.setDate(1);
        date_final.setMonth(date_inicio.getMonth() + 1);
        date_final.setFullYear(date_inicio.getFullYear());
        date_final.setDate(date_final.getDate() - 1);
        let d1 = '01';
        let m1 = date_inicio.getMonth() + 1;
        let y1 = date_inicio.getFullYear();
        let d2 = date_final.getDate();
        let m2 = date_final.getMonth() + 1;
        let y2 = date_final.getFullYear();
        if (m1 < 10) m1 = '0' + m1;
        if (d2 < 10) d2 = '0' + d2;
        if (m2 < 10) m2 = '0' + m2;
        return `&fecha_inicio=${d1}/${m1}/${y1}&fecha_fin=${d2}/${m2}/${y2}`;
      },
      getDatosFacturas() {
        const vue = this;
        vue.loading = true;
        vue.msg = '';
        let myHeaders = getheadersrest();
        let url = `${this.api_rest}/api/pagos/facturas?nit_empresa=${this.nicsel}${this.getfechasrango()}`;
        let requestOptions = { method: 'GET', headers: myHeaders };
        window.console.log(myHeaders, url);

        fetch(url, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (!result) result = [];
            vue.getDatos(result);
            vue.loading = false;
            if (vue.facturas.length == 0) {
              vue.msg = 'No se han encontrado facturas según los datos de búsqueda ingresados.';
            }
          })
          .catch((err) => {
            vue.loading = false;
            window.console.log(err);
          });
      },
      parseDatosForExcel(datos) {
        datos.forEach((_x, i) => {
          let dato = {
            especificacion: '3',
            nro: i + 1,
            fecha_factura: '',
            nro_factura: '',
            nro_autorizacion: '',
            estado: '',
            nit_cliente: '',
            razon_social: '',
            importe_total_venta: '',
            importe_iva: '',
            exportaciones: '',
            ventas_tasa_cero: '',
            subtotal: '',
            descuentos_iva: '',
            importe_fiscal: '',
            debito_fiscal: '',
            codigo_control: '',
          };
          window.console.log(dato);
        });
      },
      getsucursalesall() {
        const vue = this;
        vue.nics = [];
        let qs = gql`
          query {
            getSucursales {
              id nit_id direccion telefono ciudad numero_sucursal
            }
            getNits {
              id nombre descripcion nro estado
            }
          }
        `;
        this.$apollo
          .query({ query: qs })
          .then((data) => {
            if (!data.data.getSucursales) data.data.getSucursales = [];
            window.console.log('sucursales: ', data.data);
            vue.sucursales = data.data.getSucursales;
            vue.nits = data.data.getNits;
            vue.nits.forEach((x) => {
              vue.nics.push(x.nro);
            });
            let sucbysedes = vue.sucursales;
            window.console.log('NITS: ', vue.nits);
            window.console.log('SUCURALES: ', vue.sucursales, sucbysedes);
          })
          .catch((error) => {
            window.console.error(error);
          });
      },
    },
    mounted() {
      let anio = new Date().getFullYear();
      this.gestion = anio;
      this.getsucursalesall();
      this.sede = this.$store.state.CARGO.idsede;
    },
  };
</script>

<style scoped>
.lfe-page { min-height: 100vh; background: #f5f7fa; }

.lfe-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.lfe-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.lfe-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.lfe-body { padding: 20px 24px; }

.lfe-filters-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }
.lfe-filters-card__title {
  font-size: 0.8rem !important; font-weight: 700 !important;
  color: #283593; letter-spacing: 0.02em; border-bottom: 1px solid #e8edf7;
}

.lfe-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.lfe-table-toolbar { background: #fafbff; border-bottom: 1px solid #e8edf7; }

.lfe-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.lfe-table >>> tbody tr:hover { background: #f0f4ff !important; }
.lfe-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 4px 12px !important;
}
.lfe-table >>> tbody tr.lfe-row--anulada { background: #FCCDCD !important; }
.lfe-table >>> tbody tr.lfe-row--anulada:hover { background: #f9b7b7 !important; }

.lfe-detail-card { border-radius: 8px !important; overflow: hidden; }
.lfe-detail-header {
  background: linear-gradient(120deg, #1a237e 0%, #283593 100%);
  padding: 10px 16px;
}

.lfe-drow {
  display: flex;
  gap: 4px;
  margin-bottom: 4px;
  font-size: 0.78rem;
  line-height: 1.4;
}
.lfe-dk {
  color: #78909c;
  min-width: 110px;
  flex-shrink: 0;
}
.lfe-dv {
  color: #263238;
  font-weight: 500;
  word-break: break-all;
}
</style>
